<!-- <div class="bg-primary pt-4">
    <div class="container">
        <p class="size-0 text-light text-center max-center max-700 mb-4">
            هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد ,هذا النص هو مثال لنص يمكن أن يستبدل في نفس
            هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد ,هذا النص هو مثال لنص يمكن أن .
        </p>
        <div class="flex flex-wrap flex-space-between flex-middle max-center max-500 mb-4">
            <p class="size-1 text-light">
                <strong>
                    تليفون :
                </strong>
                ٠١٠٢٣٤٤٥٥٦٦٦ - ٠٢٢٢٣٣٤٥٦
            </p>
            <p class="size-1 text-light">
                <strong>
                    الايميل :
                </strong>
                simple12@google.com
            </p>
        </div>
        <div class="flex flex-center flex-middle mb-4">
            <a href="#" class="bg-light text-fb footer-icon mtb-1 mlr-1">
                <i class="fa fa-facebook"></i>
            </a>
            <a href="#" class="bg-light text-twitter footer-icon mtb-1 mlr-1">
                <i class="fa fa-twitter"></i>
            </a>
            <a href="#" class="bg-light text-gplus footer-icon mtb-1 mlr-1">
                <i class="fa fa-google-plus"></i>
            </a>
        </div>
    </div>
    <div class="bottom-footer ptb-2">
        <div class="container">
            <p class="size-0 text-light text-center">
                © ٢٠١٨ travelzad all rights reserved.
            </p>
        </div>
    </div>
</div> -->
<!-- ----------------------------------------------------------------------- -->
<!--                               CopyRights                                -->
<!-- ----------------------------------------------------------------------- -->

<section class="text-center">
  <p class="copyright">&copy; 2019 Noor. All RIGHTS RESERVED</p>
</section>
